<template>
  <div>
    <material-card
      :title="title"
      color="dover-blue">
      <v-layout
        row
        wrap>
        <v-flex
          id="printContacts"
          xs12
          md12
          lg12>
          <v-data-table
            :headers="headers"
            :items="contactsData"
            :no-data-text="`${ Maglink.NoDataMessage(false) }`"
            :no-results-text="`${ Maglink.NoDataMessage(true) }`"
            hide-actions>
            <template
              slot="headerCell"
              slot-scope="{ header }">
              <span
                class="dover-light-blue-color"
                v-text="header.text"/>
            </template>
            <template
              slot="items"
              slot-scope="{ index, item }"
              class="dover-light-blue-color">
              <td>{{ item.name }}</td>
              <td>{{ item.email }}</td>
              <!--  <td>{{ item.phone }}</td> -->
              <td>
                <v-icon
                  small
                  class="mr-2"
                  @click="editContact(item)">
                  mdi-pencil
                </v-icon>
                <v-icon
                  small
                  @click="deleteContact(item)">
                  mdi-delete
                </v-icon>
              </td>
            </template>
            <template slot="footer">
              <v-btn
                color="primary"
                flat
                @click="newContact">
                {{ $t('New contact') }}
              </v-btn>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex
          xs6
          md6
          lg6>
          <v-dialog
            v-model="dialog"
            persistent
            width="800px">
            <v-card>
              <v-card-title
                class="headline grey lighten-2"
                primary-title>
                {{ $t('New contact') }}
              </v-card-title>
              <v-card-text>
                <v-form
                  ref="form"
                  v-model="isValidationOk"
                  lazy-validation>
                  <v-container
                    py-0>
                    <v-layout
                      wrap>
                      <v-flex
                        xs12
                        md5>
                        <v-text-field
                          v-model.trim="contact.name"
                          :rules="rules.required.concat(rules.max30)"
                          :counter="30"
                          :label="`${ $t('Name') }`"
                          class="dover-input"/>
                      </v-flex>
                      <v-flex
                        xs12
                        md7>
                        <v-text-field
                          v-model.trim="contact.email"
                          :rules="rules.required.concat(rules.email)"
                          :label="`${ $t('Email') }`"
                          class="dover-input"/>
                      </v-flex>
                      <!--
                  <v-flex
                    xs12
                    md4>
                    <v-text-field
                      v-model.trim="contact.phone"
                      :label="`${ $t('Mobile phone') }`"
                      class="dover-input"/>
                  </v-flex>
                    -->
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>

              <v-divider/>

              <v-card-actions>
                <v-flex
                  xs10
                  md10
                  text-xs-right>
                  <v-btn
                    color="primary"
                    flat
                    @click="closeDialog(false)">
                    {{ $t('Cancel') }}
                  </v-btn>
                </v-flex>
                <v-flex
                  xs2
                  md2
                  text-xs-right>
                  <v-btn
                    :disabled="!isValidationOk"
                    color="secondary"
                    flat
                    @click="closeDialog(true)">
                    {{ $t('Save') }}
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
        <v-flex
          xs6
          md6
          lg6
          text-xs-right>
          <v-btn
            small
            class="mx-0 font-weight-light"
            color="dover-blue"
            @click="onPrintForm">
            {{ $t('Print') }}
          </v-btn>
        </v-flex>
    </v-layout></material-card>
  </div>
</template>

<script>
import { i18n } from '@/i18n'
import Vue from 'vue'
import print from 'print-js'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    contactsData: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data: () => ({
    isValidationOk: false,
    rules: {
      required: [ v => Vue.prototype.Maglink.RulesRequired(v) ],
      email: [ v => Vue.prototype.Maglink.RulesEmail(v) ],
      max30: [ v => Vue.prototype.Maglink.RulesMaxLen(v, 30) ]
    },
    contact: {
      id: 0,
      name: '',
      email: '',
      phone: ''
    },
    headers: [
      { sortable: false, text: i18n.t('Name') },
      { sortable: false, text: i18n.t('Email') },
      { sortable: false, text: '' }
    ],
    //  { sortable: false, text: i18n.t('Mobile phone') },
    dialog: false
  }),
  mounted () {
    this.isValidationOk = false
  },
  methods: {
    deleteContact (contact) {
      this.$emit('deleteContact', contact)
    },
    newContact () {
      this.contact = { id: 0, name: '', email: '', phone: '' }
      this.dialog = true
    },
    editContact (contact) {
      this.contact = contact
      this.dialog = true
    },
    closeDialog (save) {
      if (save) {
        this.$emit('saveContact', this.contact)
      }
      this.dialog = false
    },
    onPrintForm () {
      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }

      let name = this.title
      print({
        printable: 'printContacts',
        type: 'html',
        header: name,
        headerStyle: 'font-weight: 100;',
        scanStyles: false,
        css: stylesHtml
      })
    }
  }
}
</script>
